import { RouteType } from "../../../types/RouteType";

const holdManagementRoute: RouteType = {
    name: "Hold Management",
    path: "/production/hold-management/:holdId?",
    defaultParams: {
        holdId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./HoldManagement.Header"),
            title: "Hold Management",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./HoldManagement.Container"),
            grayBackground: false,
        },
    },
    group: 'Production',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const holdManagementStore = rootStore.holdManagementStore;
            if (holdManagementStore && typeof holdManagementStore === 'object' && 'loadHolds' in holdManagementStore) {
                await (holdManagementStore as any).loadHolds(params.holdId);
            }
            return true;
        } catch (error) {
            console.error("Failed to load holds:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.holdId !== previousParams?.holdId) {
            const holdManagementStore = rootStore.holdManagementStore;
            if (holdManagementStore && typeof holdManagementStore === 'object' && 'loadHolds' in holdManagementStore) {
                await (holdManagementStore as any).loadHolds(params.holdId);
            }
        }
    },
    dialogs: [],
};

export default holdManagementRoute;
